import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const attempts = ['Intentar "razonar" con alguien que no quiere tener razón, sino tener el control.', 'Mandar audios eternos descargando tu frustración (que después terminan en manos de un abogado).', 'Borrar y escribir mensajes durante media hora para terminar mandando algo que igual te hace sentir mal.', 'Creer que si sos "bueno" y cedés en todo, el otro va a dejar de pincharte.', 'Dejar el celular en silencio pero estar mirando la pantalla cada 5 minutos por pura ansiedad.'];
export function FailedAttempts() {
  return <section className="bg-[#17304F] py-24 px-6" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-71">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-72">
            Lo que ya intentaste (y por qué no funcionó)
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-73">
          {attempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm border border-slate-100" data-id="element-74">
              <div className="flex-shrink-0 mt-1 bg-red-100 p-1.5 rounded-full" data-id="element-75">
                <X className="w-5 h-5 text-red-600" strokeWidth={3} data-id="element-76" />
              </div>
              <p className="text-lg text-slate-700 font-medium" data-id="element-77">{attempt}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}